'use client';
import { cn } from '@dolcevia/lib/utils';
import { buttonVariants } from '@dolcevia/ui/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@dolcevia/ui/components/ui/select';
import { Bike as BikeSVG } from '@dolcevia/ui/svg/bike';
import { useTranslations } from 'next-intl';
import Link from 'next/link';
import { useState } from 'react';

export const CommonHeroActions = () => {
  const t = useTranslations('Home.Hero');
  const [selectedType, setSelectedType] = useState<string | undefined>();
  return (
    <div className="grid grid-cols-2 gap-2 w-full">
      <div className="grid w-full">
        <Select onValueChange={setSelectedType}>
          <SelectTrigger>
            <SelectValue placeholder="Type" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="/locations-electrique#bikes">
              🧭 {t('Aller-simple')}
            </SelectItem>
            <SelectItem value="/destinations">🌍 {t('Pack voyage')}</SelectItem>
            <SelectItem value="/locations#bikes">🛎 {t('Location')}</SelectItem>
          </SelectContent>
        </Select>
      </div>
      <div className="grid">
        <Link
          className={cn(buttonVariants({ variant: 'secondary' }), '')}
          href={selectedType ?? '/locations#bikes'}
        >
          {t('Planifiez')}{' '}
          <BikeSVG
            mainColor="#03192C"
            secondaryColor="#03192C"
            svgProps={{ className: 'h-[15px] w-auto pl-2' }}
          />
        </Link>
      </div>
    </div>
  );
};
